import React, { useEffect, useState } from 'react';
import ContactContainer from './ContactContainer';
import { Link } from 'react-router-dom';
import MyLoader from '../Shared/MyLoader';
// import PageBanner from '../CommonPages/PageBanner';
// import Loader from '../Shared/Loader';
// import '../../../public/images/breadcrumb/contactUs.png'
// import '../../../public/images/breadcrumb/contactUs.png'

const Contact = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate an API call
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);
    }, []);

    if (isLoading) {
        // return <Loader/>;
        return <MyLoader/>;
    }
    return (
        <>
            {/* {loading ? (
                <Loader />
            ) : (
                <> */}
                    {/* <PageBanner pageTitle='Pages' title="Contact" activePage="Contact"></PageBanner> */}
                    <div className="page_header">
                        <div className="page_header_inner contact_breadcrumb" >
                            <div className="container">
                                <div className="page_header_content d-flex align-items-center justify-content-between">
                                    <h2 className="heading">Contact</h2>
                                    <ul className="breadcrumb d-flex align-items-center">
                                        <li><Link to="/">Home</Link></li>
                                        
                                        <li className="active">Contact</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ContactContainer />
                {/* </>
            )} */}
        </>
    );
};

export default Contact;